import styled from "@emotion/styled/macro";
import { ReactComponent as CloseIconSvg } from "../../assets/close-icon.svg";

export const CloseIcon = styled(CloseIconSvg)`
  width: 9.8px;
  height: 9.8px;

  fill: currentColor;
`;
